import React, { useContext, useEffect } from "react";
import { navigate } from "@reach/router";
import axios from "axios";

import { LanguageContext, UserContext } from "../contexts/Context";
import OrderLoading from "../newcomponents/OrderLoading";

const getCookie = (name) => {
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name}=([^;]*)`)
  );

  return match ? decodeURIComponent(match[1]) : null;
};

const PaymentLoading = () => {
  const { lanIndex } = useContext(UserContext);
  const language = useContext(LanguageContext)[lanIndex];

  useEffect(() => {
    let isActive = true;

    const checkPayment = async () => {
      const token = getCookie("token");
      const orderId = getCookie("orderId");

      if (!token || !orderId) {
   
        navigate("/payment/fail", { replace: true });
        return;
      }

      try {
        const response = await axios.post(
          "/v2/api/payment/check",
          { orderId },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (isActive) {
          navigate(
            response.status === 200 ? "/payment/success" : "/payment/fail",
            { replace: true }
          );
        }
      } catch {
        if (isActive) {
          navigate("/payment/fail", { replace: true });
        }
      }
    };

    checkPayment();

    return () => {
      isActive = false;
    };
  }, []);

  return (
    <OrderLoading
      title={language.processingPayment}
      description={language.processingPaymentDescription}
      fullScreen
    />
  );
};

export default PaymentLoading;
